/**
 * True when the browser holds a Supabase auth token (or we just came back from
 * an auth redirect). Anonymous visitors never need the ~53 KiB supabase-js
 * chunk on first load, so callers can skip downloading it entirely.
 */
export function hasStoredSession(): boolean {
  if (typeof window === "undefined") return false;
  try {
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith("sb-") && key.endsWith("-auth-token")) return true;
    }
  } catch {}
  const hash = window.location.hash || "";
  return hash.includes("access_token") || hash.includes("type=");
}
